function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.29481 0.0630875L0.243895 5.2847C-0.109549 5.48778 -0.0646365 5.97987 0.286855 6.12828L2.36261 6.99919L7.97281 2.05487C8.08021 1.95919 8.23253 2.10565 8.14075 2.21695L3.43661 7.94822V9.52017C3.43661 9.98102 3.99314 10.1626 4.26653 9.8287L5.50651 8.31924L7.93962 9.33857C8.2169 9.45573 8.53325 9.28194 8.58402 8.98317L9.98999 0.547365C10.0564 0.152913 9.63264 -0.132186 9.29481 0.0630875Z",
  fill: "white"
});

const SvgIconReply = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconReply, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-reply.1c764870.svg";
export { ForwardRef as ReactComponent };